module.exports = __webpack_public_path__ + "img/explain_ellipse.69b9365d.svg";